<template>
 
  <router-view/>

</template>

<script>
// import {listUser} from '@/api/user'
// import {test} from '@/api/test'

// import 'element-plus/theme-chalk/dark/css-vars.css'


export default {
  name: 'App',
  components: {
   // HelloWorld
  },
  mounted(){
    // this.$router.push({name:'login'})
    // listUser().then(res=>{
    //   console.log(res)
    // })
    // test().then(res=>{
    //   console.log(res)
    // })
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
